import { invariantResponse } from '@epic-web/invariant'
import { json, type MetaFunction } from '@remix-run/node'
import { NavLink, useLoaderData } from '@remix-run/react'
import { prisma } from '#app/utils/db.server.js'
import { getPaintingImgSrc } from '#app/utils/misc.js'

export const meta: MetaFunction = () => [
	{ title: 'Art by Vero Miller - ¡Hola!' },
]

export async function loader() {
	const homepageData = await prisma.homePage.findFirst({
		select: {
			text: true,
			title: true,
			image: {
				select: {
					id: true,
					altText: true,
				},
			},
		},
	})

	const paintings = await prisma.painting.findMany({
		select: {
			images: {
				take: 1,
				select: {
					id: true,
					altText: true,
				},
			},
		},
		where: {
			images: { some: {} },
		},
		take: 4,
	})

	invariantResponse(paintings, 'images not found', { status: 404 })
	invariantResponse(homepageData, 'images not found', { status: 404 })

	return json({
		images: paintings.map((paintings) => paintings.images[0]),
		homepageData,
	})
}

export default function Index() {
	const { images, homepageData } = useLoaderData<typeof loader>()
	return (
		<main className="mx-10 mt-10 flex flex-col md:mx-20">
			<div className="relative">
				<img
					src={`/resources/homepage-image/${homepageData?.image[0]?.id}`}
					className="float-left mr-4 aspect-auto w-36 md:w-64"
				/>

				<span className="font-buongirno text-special">
					{homepageData.title}
				</span>
				<p className="-mt-4 whitespace-break-spaces text-body-xs md:text-body-md">
					{homepageData.text}
				</p>
			</div>
			<section className="relative mb-12 mt-4 flex flex-col items-center justify-center md:mt-12">
				<h2 className="mb-4 text-center text-body-sm md:text-body-lg">
					Explore my gallery and find a piece that connects with you! ♡
				</h2>
				<div className="flex">
					<div className="flex flex-wrap justify-center gap-12 md:gap-8">
						{images.map((image) => {
							return (
								<NavLink key={image.id} to="paintings">
									<img
										className="aspect-auto w-36 md:w-64"
										src={getPaintingImgSrc(image.id)}
									/>
								</NavLink>
							)
						})}
					</div>
				</div>
			</section>
		</main>
	)
}
